/**
 * Unit persistence schema.
 *
 * Invariants:
 * - `unit.key` is canonical and must align with `UNIT_DEFINITIONS`.
 * - Localization rows are unique per `(unitKey, language, region)`.
 *
 * @see `packages/core/docs/database.md`
 */
import { foreignKey, pgEnum, pgTable, primaryKey, text } from "drizzle-orm/pg-core";
import type { Unit } from ".";
import { language, locale } from "../locale/locale.sql";
import { UNIT_TYPES } from "./definitions";

export const unitType = pgEnum("unit_type", UNIT_TYPES);

export const unit = pgTable("unit", {
  key: text("key").primaryKey().$type<Unit.Key>(),
  type: unitType("type").notNull(),
  defaultName: text("default_name").notNull(),
  defaultAliases: text("default_aliases").array().notNull(),
});

export const unitLocalization = pgTable(
  "unit_localization",
  {
    unitKey: text("unit_key")
      .references(() => unit.key)
      .$type<Unit.Key>()
      .notNull(),
    language: text("language")
      .notNull()
      .references(() => language.code),
    region: text("region"),
    name: text("name").notNull(),
    aliases: text("aliases").array().notNull(),
  },
  (t) => [
    primaryKey({ name: "unit_localization_pk", columns: [t.unitKey, t.language, t.region] }),
    foreignKey({
      name: "unit_localization_locale_fk",
      columns: [t.language, t.region],
      foreignColumns: [locale.language, locale.region],
    }),
  ],
);
